module.exports = __webpack_public_path__ + "img/AneuShape.3074044d.png";